// 服务到期提醒
const serviceReminder = () => import('../../pages/serviceReminder/serviceReminder.vue')
const router = [
  {
    path: '/serviceReminder/serviceReminder/:token/:sisscloudtokenid?/:otherData?',
    component: serviceReminder,
    name: 'serviceReminder',
    meta: {
      title: '服务到期提醒'
    },
    props(route) {
      return {
        token: route.params.token,
        sisscloudtokenid: route.params.sisscloudtokenid,
        otherData: route.params.otherData
      }
    }
  }
]
export default router
